"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function toSnakeCase(str) {
    return str.replace(/([A-Z])/g, '_$&').toLowerCase();
}
exports.toSnakeCase = toSnakeCase;
function parseWidthHeight(src) {
    var re = /(?:[wh]_)(\d+)/g;
    try {
        return { width: +re.exec(src)[1], height: +re.exec(src)[1] };
    }
    catch (e) {
        return {};
    }
}
exports.parseWidthHeight = parseWidthHeight;
function parseImageName(src) {
    var filename = src.substring(src.lastIndexOf('/') + 1);
    if (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i.test(filename)) {
        return filename;
    }
    return src;
}
exports.parseImageName = parseImageName;
//# sourceMappingURL=stringUtils.js.map